var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07143 4.90628C9.90371 5.18804 10.5 5.94838 10.5 6.84211V10.9474C10.5 12.081 9.54062 13 8.35714 13H2.64286C1.45939 13 0.5 12.081 0.5 10.9474V6.84211C0.5 5.94838 1.09629 5.18804 1.92857 4.90628V3.42105C1.92857 1.53166 3.52756 0 5.5 0C7.47244 0 9.07143 1.53166 9.07143 3.42105V4.90628ZM3.35714 4.78947H7.64286V3.42105C7.64286 2.28741 6.68347 1.36842 5.5 1.36842C4.31653 1.36842 3.35714 2.28741 3.35714 3.42105V4.78947ZM5.5 6.84211C4.71101 6.84211 4.07143 7.45478 4.07143 8.21053C4.07143 8.71704 4.35871 9.15925 4.78571 9.39587V10.9474H6.21429V9.39587C6.64129 9.15925 6.92857 8.71704 6.92857 8.21053C6.92857 7.45478 6.28899 6.84211 5.5 6.84211Z",
    fill: "#CED8DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.885292bb5be48974b68f24040ca16b13.svg";
export { ForwardRef as ReactComponent };